import {ChangeDetectionStrategy, Component, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, firstValueFrom, Observable, of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {NgrxBusy, withBusy} from 'ngrx-busy';
import {AnimationsService, FlashlightAnimation} from './animations.service';
import {SideNav} from 'shared/sidenav';
import {AnimationsUploadFormComponent} from './animations-upload-form/animations-upload-form.component';

interface AnimationsState {
  animations: FlashlightAnimation[];
  error: boolean;
}

@Component({
  selector: 'app-animations',
  templateUrl: './animations.component.html',
  styleUrls: ['./animations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AnimationsComponent implements OnInit {
  @ViewChild(NgrxBusy, {static: true}) busy: NgrxBusy;

  private readonly refresh$ = new BehaviorSubject<void>(undefined);
  state$: Observable<AnimationsState>;

  constructor(private animationsService: AnimationsService,
              private sidenav: SideNav) {
  }

  ngOnInit(): void {
    this.state$ = this.refresh$.pipe(
      switchMap(() => this.animationsService.getAnimations().pipe(
        map(animations => ({animations: animations || [], error: false})),
        catchError(() => of({animations: [], error: true})),
        withBusy(() => this.busy)
      ))
    );
  }

  async openUploadForm(): Promise<void> {
    const uploaded = await firstValueFrom(this.sidenav.open(AnimationsUploadFormComponent, {}).beforeClosed());
    if (uploaded) {
      this.refresh$.next();
    }
  }
}
